function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { Modal, ModalBody } from "reactstrap";

class CoveredOverlayModal extends React.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "state", {
      modalStyle: {
        padding: '0',
        position: 'absolute',
        height: 'auto',
        width: 'auto',
        top: '0',
        left: '0'
      },
      modalHeight: 0
    });

    _defineProperty(this, "render", () => {
      const {
        modalStyle,
        children,
        ...restProps
      } = this.props;
      return /*#__PURE__*/React.createElement(Modal, _extends({}, restProps, {
        fade: false,
        cssModule: {
          'modal-dialog': 'clear-modal-dialog',
          'modal-content': 'clear-modal-content'
        },
        onClick: e => e.stopPropagation()
      }), /*#__PURE__*/React.createElement(ModalBody, {
        style: { ...this.state.modalStyle,
          ...modalStyle
        }
      }, /*#__PURE__*/React.createElement("div", {
        ref: this.modalBodyRef
      }, children)));
    });

    this.modalBodyRef = /*#__PURE__*/React.createRef();
  }

}

export default /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(CoveredOverlayModal, _extends({
  ref: ref
}, props)));